<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :ajax-params="ajaxParams"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :showHeader="showTableHeader"
            :pagination="paginateTable"
            ajax-path="phpipam/subnets"
            @rowSelected="handleRowSelected"     
        />
        <app-modal 
            width="lg:w-1/2"
            :show.sync="showPreviewModal"
            @close="showPreviewModal = false"
        >
            <template slot="header">Subnet Details</template>
            <template slot="body">
                <div class="grid">
                    <div 
                        class="border border-gray-400 text-center py-1"
                        :class="{'bg-green-500 text-white border-green-500': selected.addresses.findIndex(address => {
                            return address.ip.split('.')[3] == n;
                        }) !== -1}"
                        v-for="n in 254"
                    >.{{ n }}</div>
                </div>
            </template>
        </app-modal>
    </div>
</template>

<script>
    import http from '@/helpers/Http';
    export default {
        props: {
            showTableHeader: {
                type: Boolean,
                default: true,
            },
            paginateTable: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                tableIsLoading: false,
                refreshTable: false,
                showPreviewModal: false,
                selected: {
                    calculation: {},
                    gateway: {},
                    addresses: [],
                },
                ajaxParams:{},
                columns: [
                    {
                        title: 'Subnet',
                        field: 'subnet',
                        sorter: 'string',
                        minWidth: 250,
                    },
                    {
                        title: 'Description',
                        field: 'description',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        },
                    },
                    {
                        title: 'Usage',
                        sorter: 'string',
                        minWidth: 250,
                        formatter({_cell}) {
                            return `${_cell.row.data.used} of ${_cell.row.data.maxhosts} used`;
                        },
                    },
                ],
                actions: [
                    // {
                    //     label: 'Sync',
                    //     icon: () => import('@/icons/Sync.vue'),
                    //     handler: this.sync
                    // }
                ],
            }
        },
        methods: {
            handleRowSelected(row) {
                this.selected = row.data;
                this.showPreviewModal = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
        grid-gap: 15px;
    }
</style>